import { createSelector } from "reselect";

const selectUnits = (state) => state.unitsReducer.units;
const selectRetentions = (state) => state.wholesalerRetentions.retentions;

export const retentionsSelector = createSelector(
  [selectUnits, selectRetentions],
  (units, retentions) =>
    retentions.map((r) => ({
      ...r,
      unit: units[r.idUnit]?.number || "",
    }))
);
